function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_metro-flow-tree",
  "data-name": "Icon metro-flow-tree",
  d: "M30.334,24.407V20.823a5.4,5.4,0,0,0-5.4-5.4H21.851a2.314,2.314,0,0,1-2.314-2.314V9.526a3.7,3.7,0,1,0-3.085,0v3.585a2.314,2.314,0,0,1-2.314,2.314H11.054a5.4,5.4,0,0,0-5.4,5.4v3.585a3.7,3.7,0,1,0,3.085,0V20.823a2.314,2.314,0,0,1,2.314-2.314h3.085a5.342,5.342,0,0,0,2.314-.54v6.438a3.7,3.7,0,1,0,3.085,0V17.969a5.342,5.342,0,0,0,2.314.54h3.085a2.314,2.314,0,0,1,2.314,2.314v3.585a3.7,3.7,0,1,0,3.085,0ZM17.995,4.033A2.136,2.136,0,1,1,15.86,6.17a2.135,2.135,0,0,1,2.135-2.136ZM7.2,29.9a2.136,2.136,0,1,1,2.135-2.136A2.136,2.136,0,0,1,7.2,29.9Zm10.8,0a2.136,2.136,0,1,1,2.135-2.136A2.136,2.136,0,0,1,17.995,29.9Zm10.8,0a2.136,2.136,0,1,1,2.135-2.136A2.136,2.136,0,0,1,28.792,29.9Z",
  transform: "translate(-3.496 -2.468)",
  fill: "#1aa0e0"
});

function SvgIconCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.998,
    height: 28.998,
    viewBox: "0 0 28.998 28.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategory);
export default __webpack_public_path__ + "static/media/icon-category.c9ff968a.svg";
export { ForwardRef as ReactComponent };